import styled from 'styled-components';
import {
  maxMobile,
  maxTablet,
  maxWidth, primaryFont, primaryHeadingColor, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { Row, Col, Button } from 'antd';

import { useDispatch, useSelector } from 'react-redux';

import React, { useEffect, useState } from 'react';

import IndustriesSkeleton from 'Components/common/skeleton/IndustriesSkeleton';
import { actions } from 'Slice/ServiceLinesSlice';
import { allValueInKeyOfArrayExists, IsTablet } from 'Utils/UtilityFunctions';
import { selectLoading, selectServiceLines, selectServiceLinesEmpty } from 'Selector/ServiceLinesSelector';
import { ServiceLine } from 'Types/ServiceLinesTypes';
import Cross from 'Components/globalSearch/assets/Cross';
import EditIcon from '../company/svgIcons/EditIcon';
import BinIcon from '../company/svgIcons/BinIcon';
import IndustriesWidget from '../common/components/IndustriesWidget';

const StyleWrapper = styled.div`
  .fancy-box {
    border-radius: 10px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
    background: rgb(255, 255, 255);
    padding: 40px 50px 40px 50px;
    margin-top: 50px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 17px 16px 16px 16px;
    }

    .tabs-wrapper {
      margin-right: 5px;
      @media all and (max-width: ${maxTablet}) {
        .icon-button {
          padding: 7px;
          svg {
            height: 18px;
            path {
              fill: #7E7E7E;
            }
          }
        }
      }
    }
  
    .heading-text {
      font-family: ${secondaryFont};
      color: ${primaryHeadingColor};
      font-size: 22px;
      margin-bottom: 0;
      margin-left: 10px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 19px;
      }
      @media all and (max-width: ${maxMobile}) {
        white-space: pre;
        font-size: 18px;
      }
    }
    p {
      font-family: ${primaryFont};
      color: #5e7079;
    }
    input {
      font-size: 16px;
      padding: 7px 12px;
    }
    label {
      font-size: 12px;
    }
    h4.recommended-name{
      color:${primaryHeadingColor};
      font-weight: ${wMBold};
      font-family:${secondaryFont};
      margin-bottom:0;
      font-size:22px;
      line-height: 38px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 18px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 14px;
        line-height: 19px;
      }
    }
  }
  .industriesSection {
    margin-top: 20px;
    .search-distance-row{
      margin: 0 !important;
    }
  }
`;

const ServiceLinesSection = function ServiceLinesSection() {
  const servicelinesStore = useSelector(selectServiceLines);
  const loading = useSelector(selectLoading);
  const emptyServicelines = useSelector(selectServiceLinesEmpty);
  const [editEnable, setEditEnable] = useState(false);
  const [servicelines, setServicelines] = useState<ServiceLine[]>([]);
  const dispatch = useDispatch();
  const isTab = IsTablet();

  const getCompaniesLoadingSkeleton = () => {
    const skeletons = [];
    for (let i = 0; i < 6; i += 1) {
      skeletons.push(
        <Col span={4} className="gutter-row">
          <IndustriesSkeleton />
        </Col>,
      );
    }
    return (
      skeletons
    );
  };

  const setInitialServicelines = () => {
    const servicelinesTemp = servicelinesStore.map((v) => ({ ...v, selected: false, added: true }));
    setServicelines(servicelinesTemp);
  };

  const setChecked = (flag: boolean, id: number) => {
    const servicelinesT = servicelines.map((v) => {
      if (id === v.id) {
        return { ...v, selected: !flag };
      }
      return v;
    });
    setServicelines(servicelinesT);
  };

  const removeServicelines = () => {
    const servicelinesTemp = servicelines.filter((v) => v.selected === true);
    dispatch(actions.removeServiceLines(servicelinesTemp));
  };

  useEffect(() => {
    setInitialServicelines();
    if (editEnable && !loading) {
      setEditEnable(!editEnable);
    }
  }, [servicelinesStore]);

  return (!emptyServicelines
    ? (
      <StyleWrapper>
        <div className="fancy-box">
          <div className="d-flex justify-content-between align-items-center heading-row">
            <h1 className="heading-text primary-color">
              {`Service Lines I follow (${servicelines.length})`}
            </h1>
            <div className="tabs-wrapper">
              {!editEnable ? (
                <Button
                  className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                  onClick={() => { setEditEnable(true); }}
                  disabled={loading}
                >
                  <EditIcon />
                  {isTab ? null : (
                    <span style={{
                      marginLeft: '10px',
                      marginRight: '8px',
                    }}
                    >
                      Edit
                    </span>
                  )}
                </Button>
              ) : (
                <>
                  <Button
                    className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                    disabled={loading
                      || allValueInKeyOfArrayExists(servicelines, 'selected', false)}
                    onClick={removeServicelines}
                  >
                    <BinIcon />
                    {isTab ? null : (
                      <span style={{
                        marginLeft: '10px',
                        marginRight: '8px',
                      }}
                      >
                        Remove
                      </span>
                    )}
                  </Button>
                  <Button
                    className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                    onClick={() => { setEditEnable(false); setInitialServicelines(); }}
                    disabled={loading}
                  >
                    {isTab ? (
                      <Cross />
                    ) : (
                      <span>Cancel</span>
                    )}
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="industriesSection">
            <Row className="Grid-width-row white-layer-col" gutter={[24, 24]}>
              {loading ? getCompaniesLoadingSkeleton()
                : servicelines.map((serviceline) => (
                  <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row">
                    <IndustriesWidget
                      key={serviceline.id}
                      id={serviceline.id}
                      articleText={serviceline.name}
                      articleBanner={serviceline.image}
                      removeButton={editEnable}
                      checked={serviceline.selected}
                      setChecked={(flag) => setChecked(flag, serviceline.id)}
                      isAdded={serviceline.added}
                      followLoading={serviceline.loading}
                      isServicelines
                      pagination={serviceline.pagination}
                    />
                  </Col>
                ))}
            </Row>
          </div>
        </div>
      </StyleWrapper>
    ) : null
  );
};
export default ServiceLinesSection;
